import React from 'react'
import PropTypes from 'prop-types'
import {Stack} from '@salesforce/retail-react-app/app/components/shared/ui'
import useMultiCountryFields from './useMultiCountriesFields'
import Field from '../field'

const MultiCountriesFields = ({form, regions, countries, languages, sessionData, prefix = ''}) => {
    const {fields, loading} = useMultiCountryFields({
        form,
        regions,
        countries,
        languages,
        sessionData,
        prefix
    })

    if (loading) return <p>Loading...</p>

    return (
        <Stack spacing={4}>
            <Field
                {...fields.region}
                labelProps={{
                    fontSize: 'md',
                    lineHeight: '5',
                    fontWeight: 'bold'
                }}
                inputProps={{
                    backgroundColor: 'inputFocusBgColor',
                    color: 'textColor',
                    cursor: 'pointer',
                    fontWeight: 'medium'
                }}
            />
            <Field
                {...fields.country}
                labelProps={{
                    fontSize: 'md',
                    lineHeight: '5',
                    fontWeight: 'bold'
                }}
                inputProps={{
                    backgroundColor: fields.country.disabled ? 'borderColor1' : 'inputFocusBgColor',
                    color: 'textColor',
                    cursor: fields.country.disabled ? 'not-allowed' : 'pointer',
                    fontWeight: 'medium',
                    isDisabled: fields.country.disabled,
                    ...(fields.country.disabled && {
                        sx: {opacity: '0.99 !important'}
                    }),
                    icon: fields.country.disabled ? <></> : undefined
                }}
            />
            <Field
                key={fields.language.disabled ? 'disabled' : 'enabled'}
                {...fields.language}
                labelProps={{
                    fontSize: 'md',
                    lineHeight: '5',
                    fontWeight: 'bold'
                }}
                inputProps={{
                    backgroundColor: fields.language.disabled
                        ? 'borderColor1'
                        : 'inputFocusBgColor',
                    color: 'textColor',
                    cursor: fields.language.disabled ? 'not-allowed' : 'pointer',
                    fontWeight: 'medium',
                    isDisabled: fields.language.disabled,
                    ...(fields.language.disabled && {
                        sx: {opacity: '0.99 !important'}
                    }),
                    icon: fields.language.disabled ? <></> : undefined
                }}
            />
        </Stack>
    )
}

MultiCountriesFields.propTypes = {
    form: PropTypes.object.isRequired,
    regions: PropTypes.array.isRequired,
    countries: PropTypes.array.isRequired,
    languages: PropTypes.array.isRequired,
    sessionData: PropTypes.any,
    prefix: PropTypes.string
}

export default MultiCountriesFields
